import React from 'react'
import type { FC, ChangeEvent, ReactNode } from 'react'
import { FormControlLabel } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Checkbox as SharedUiCheckbox } from '@homeviews/shared-ui'

const useStyles = makeStyles(() =>
  createStyles({
    input: {
      '& .MuiSvgIcon-root': {
        fontSize: 28,
        fill: '#000433',
      },
    },
    label: {
      fontSize: '16px',
      lineHeight: '20px',
    },
  }),
)

type CheckboxProps = {
  children: ReactNode
  handleOnChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const Checkbox: FC<CheckboxProps> = ({ children, handleOnChange }) => {
  const classes = useStyles()
  return (
    <FormControlLabel
      control={
        <SharedUiCheckbox className={classes.input} onChange={handleOnChange} />
      }
      label={<span className={classes.label}>{children}</span>}
    />
  )
}
